// Dependencies
import React from "react";
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';

import Icon from "./Icon";

const CartIcon = ({icon, quantity, loading = false, className, theme}: any) => {
	const transitionProps: CSSTransitionProps = React.useMemo(() => ({
		timeout: Number(theme.general.transition.duration.replace('ms', '')),
		unmountOnExit: true
	}), [theme.general.transition.duration])

	return ( 
		<div className={className}>
			<Icon {...{id: theme.components.cartButton.icon.id ?? 'cartDefault'}} />
			<div className={`${className}--quantity`}>
				<CSSTransition {...transitionProps} in={ loading } >
					<span className="loading-spinner"></span>
				</CSSTransition>
				<CSSTransition {...transitionProps} in={ ! loading } >
					<span>{quantity}</span>
				</CSSTransition>
			</div>
		</div>
	)
}

export default CartIcon; 